import React, { useState } from "react";
import { Layout, Drawer } from "antd";
import { Outlet } from "react-router-dom";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";
import "../layout/layout.scss"
import { FaTimes } from "react-icons/fa";

const { Content } = Layout;

const AuthLayout = (props) => {
  const [open, setOpen] = useState(false);

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>

      <Layout>
        <Header setOpen={setOpen} />
        <Content className="layout-content">
          <Outlet>{props}</Outlet>
        </Content>
        <Footer />


        <Drawer
          onClose={onClose}
          open={open}
          placement="left"
          closable={false}
        >
          <div onClick={onClose} style={{ position: 'absolute', right: 16, top: 16 }}>
            <FaTimes style={{ fontSize: 20 }} />
          </div>
          <Sidebar onClose={onClose} />
        </Drawer>

      </Layout>
    </>
  );
};

export default AuthLayout;